<template>
  <section class="catalog-page">
    <div class="catalog-header">
      <div>
        <h1>Catálogos de prestaciones</h1>
        <p>Importá el Excel recibido y consultá la información publicada en los sitios.</p>
      </div>
      <div class="import-box">
        <label class="file-selector">
          <b-icon icon="file-excel" />
          <span>{{ file ? file.name : 'Seleccionar Excel' }}</span>
          <input type="file" accept=".xls,.xlsx" @change="selectFile">
        </label>
        <b-button type="is-primary" :loading="importing" :disabled="!file" @click="importFile">Importar y publicar</b-button>
      </div>
    </div>

    <b-tabs v-model="activeTab" @input="changeType">
      <b-tab-item v-for="catalog in catalogs" :key="catalog.type" :label="catalog.label" />
    </b-tabs>

    <div class="toolbar">
      <b-input v-model="search" icon="magnify" placeholder="Buscar..." @keyup.native.enter="load" />
      <b-button icon-left="magnify" @click="load">Buscar</b-button>
      <span v-if="metadata" class="metadata">Última carga: {{ formatDate(metadata.updated_at) }} · {{ metadata.row_count }} registros · {{ metadata.source_filename }}</span>
    </div>

    <div class="catalog-table-scroll">
      <b-table :data="rows" :loading="loading" striped hoverable scrollable>
        <b-table-column v-for="column in columns" :key="column.field" v-slot="props" :field="column.field" :label="column.label">
          {{ display(props.row, column.field) }}
        </b-table-column>
        <template #empty><div class="has-text-centered py-6">Todavía no hay datos para mostrar.</div></template>
      </b-table>
    </div>
    <b-pagination
      v-if="total > perPage"
      class="catalog-pagination"
      :total="total"
      :per-page="perPage"
      :current.sync="page"
      order="is-centered"
      @change="changePage"
    />
  </section>
</template>

<script>
export default {
  name: 'BenefitCatalogs',
  data: () => ({
    catalogs: [
      { type: 'dentists', label: 'Odontólogos' },
      { type: 'pharmacies', label: 'Farmacias' },
      { type: 'vademecum', label: 'Vademécum' },
    ],
    activeTab: 0, file: null, importing: false, loading: false,
    rows: [], metadata: null, search: '', page: 1, perPage: 10, total: 0,
  }),
  computed: {
    type() { return this.catalogs[this.activeTab].type; },
    columns() {
      if (this.type === 'dentists') return [{field:'name',label:'Prestador'},{field:'speciality',label:'Especialidad'},{field:'address',label:'Dirección'},{field:'locality',label:'Localidad'},{field:'province',label:'Provincia'},{field:'phone',label:'Teléfono'},{field:'details',label:'Planes'}];
      if (this.type === 'pharmacies') return [{field:'name',label:'Farmacia'},{field:'code',label:'Código'},{field:'address',label:'Domicilio'},{field:'locality',label:'Zona'},{field:'province',label:'Región'},{field:'phone',label:'Teléfono'}];
      return [{field:'drug',label:'Principio activo'},{field:'extra.potency',label:'Potencia'},{field:'extra.content',label:'Contenido'},{field:'name',label:'Nombre comercial'},{field:'speciality',label:'Forma farmacéutica'},{field:'laboratory',label:'Laboratorio'},{field:'details',label:'Observaciones'}];
    },
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await this.$repositories.benefitCatalogs.list(this.type, { search: this.search, page: this.page, per_page: this.perPage });
        this.rows = data.data; this.total = data.total; this.metadata = data.catalog;
      } catch (error) { this.$buefy.toast.open({ message: 'No se pudo cargar el catálogo.', type: 'is-danger' }); }
      finally { this.loading = false; }
    },
    async importFile() {
      this.importing = true;
      try {
        const { data } = await this.$repositories.benefitCatalogs.import(this.type, this.file);
        this.file = null; this.page = 1; await this.load();
        this.$buefy.toast.open({ message: `${data.row_count} registros importados correctamente.`, type: 'is-success' });
      } catch (error) {
        const message = error.response && error.response.data && (error.response.data.message || Object.values(error.response.data.errors || {})[0]);
        this.$buefy.toast.open({ message: String(message || 'No se pudo importar el archivo.'), type: 'is-danger', duration: 6000 });
      } finally { this.importing = false; }
    },
    selectFile(event) { this.file = event.target.files && event.target.files[0] ? event.target.files[0] : null; },
    changeType() { this.file = null; this.search = ''; this.page = 1; this.load(); },
    changePage(page) { this.page = page; this.load(); },
    display(row, field) {
      return field.split('.').reduce((value, key) => value && value[key], row) || '—';
    },
    formatDate(value) { return value ? new Date(value).toLocaleString('es-AR') : '—'; },
  },
};
</script>

<style scoped>
.catalog-page { margin: 2%; }
.catalog-header, .toolbar, .import-box { display: flex; align-items: center; gap: 12px; }
.catalog-header { justify-content: space-between; margin-bottom: 20px; }
.catalog-header h1 { color: #00758f; font-size: 26px; font-weight: 700; }
.toolbar { margin: 12px 0 20px; flex-wrap: wrap; }
.toolbar .control { min-width: 280px; }
.metadata { color: #667085; font-size: 13px; margin-left: auto; }
.catalog-table-scroll { max-height: calc(100vh - 390px); min-height: 360px; overflow: auto; }
.catalog-table-scroll ::v-deep thead th { background: #fff; position: sticky; top: 0; z-index: 2; }
.catalog-pagination { margin: 16px 0 0; }
.file-selector { align-items: center; background: #fff; border: 2px solid #8bb9c6; border-radius: 24px; color: #00758f; cursor: pointer; display: inline-flex; font-weight: 700; gap: 8px; max-width: 360px; overflow: hidden; padding: 10px 18px; text-overflow: ellipsis; white-space: nowrap; }
.file-selector input { height: 1px; opacity: 0; position: absolute; width: 1px; }
@media (max-width: 768px) { .catalog-header, .import-box { align-items: stretch; flex-direction: column; } .metadata { margin-left: 0; } }
</style>
